import { DateTime } from 'luxon';

import {
  CheckMetadata,
  createSimpleCheckMetadataArray,
} from 'dashboard/components/ChecksTable/computeCheckMetadata';
import { formatDate } from 'dashboard/lib/utils/formatters';
import { CheckStatus, DocumentExpiredDetection } from 'dashboard/models/check';

export const computeDocumentExpiredDetectionMetadata = (
  check: DocumentExpiredDetection,
): CheckMetadata => {
  const {
    'expiration-check-date': expirationCheckDate,
    'document-expiration-date': documentExpirationDate,
  } = check.metadata || {};

  // If check passes when submitted date is 1 day after check date date, then server included a
  // buffer to account for timezone difference between client time and server UTC time. We show
  // a special message to explain this! See https://en.wikipedia.org/wiki/Anywhere_on_Earth.
  const passedWithAnywhereOnEarthBuffer =
    check.status === CheckStatus.Passed &&
    expirationCheckDate &&
    documentExpirationDate &&
    Math.floor(
      DateTime.fromISO(expirationCheckDate).diff(DateTime.fromISO(documentExpirationDate), 'days')
        .days,
    ) === 1;

  let expirationCheckDateHelpIconMessage;
  if (passedWithAnywhereOnEarthBuffer) {
    // Show message explaining that check passed due to Anywhere on Earth buffer.
    if (passedWithAnywhereOnEarthBuffer) {
      expirationCheckDateHelpIconMessage = 'Accepted until this date Anywhere on Earth (AoE).';
    }
  }

  return {
    metadata: createSimpleCheckMetadataArray([
      {
        label: 'Document Expiration Date',
        value: formatDate(documentExpirationDate) || '-',
      },
      {
        label: 'Check Run Date',
        value: `${formatDate(expirationCheckDate) || '-'}${passedWithAnywhereOnEarthBuffer ? ' (AoE)' : ''}`,
        labelHelpText: passedWithAnywhereOnEarthBuffer
          ? expirationCheckDateHelpIconMessage
          : undefined,
      },
    ]),
    hideIfVerificationPassed: false,
  };
};
